import React from 'react'
import * as c from '../const'
import * as s from '../svg/svg'
import InfoPage from '../components/parts/InfoPage'

const ThankYou = () => {
  return (
    <InfoPage
      meta={c.SEO.thankYou}
      icon={<s.Email />}
      title={`Registration successful!`}
      text={(
        <>
          <p>Within the next 30 minutes, you will receive an e-mail with a link to your vending Administration console. </p>
          <p>Follow that link to receive instructions for your final vending machine setup. </p>
          <p>You may close this window.</p>
        </>
      )}
    />
  )
}

export default ThankYou
